import { ActionTypes } from "store/actionTypes";

type Doc = { id: string | number; [key: string]: any };

const initialState: {
  isLoading: boolean;
  error: string | null;
  docs: Doc[];
  selectedDoc: Doc | null;
  selectedCustomerId: string | null;
} = {
  isLoading: false,
  error: null,
  docs: [],
  selectedDoc: null,
  selectedCustomerId: null,
};

const docReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case ActionTypes.DOC_LOADING:
      return { ...state, isLoading: true, error: null };
    case ActionTypes.DOC_ERROR:
      return { ...state, isLoading: false, error: action.payload };
    case ActionTypes.GET_DOCS:
      // Ensure docs is always an array
      let docsData = [];
      if (Array.isArray(action.payload)) {
        docsData = action.payload;
      } else if (action.payload?.rows && Array.isArray(action.payload.rows)) {
        docsData = action.payload.rows;
      } else if (action.payload && Array.isArray(action.payload)) {
        docsData = action.payload;
      }
      return {
        ...state,
        isLoading: false,
        docs: docsData,
      };
    case ActionTypes.GET_DOC_BY_ID:
      return { ...state, isLoading: false, selectedDoc: action.payload };
    case ActionTypes.ADD_DOC:
      return {
        ...state,
        isLoading: false,
        docs: [...state.docs, action.payload],
      };
    case ActionTypes.UPDATE_DOC:
      return {
        ...state,
        isLoading: false,
        docs: state.docs.map((d) =>
          d.id === action.payload.id ? { ...d, ...action.payload } : d
        ),
        selectedDoc:
          state.selectedDoc?.id === action.payload.id
            ? { ...state.selectedDoc, ...action.payload }
            : state.selectedDoc,
      };
    case ActionTypes.DELETE_DOC:
      return {
        ...state,
        isLoading: false,
        docs: state.docs.filter((d) => d.id !== action.payload),
        selectedDoc:
          state.selectedDoc?.id === action.payload ? null : state.selectedDoc,
      };
    case ActionTypes.SET_DOC_CUSTOMER_SELECTION:
      return {
        ...state,
        selectedCustomerId: action.payload,
      };
    default:
      return state;
  }
};

export default docReducer;

